import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AppPlatformService {

  constructor(private platform: Platform,) { }

  isAppPlatform(): boolean {
    return this.platform.is('capacitor') && ( this.platform.is('ios') || this.platform.is('android') );
  }

  isIosHibridApp(): boolean {
    return this.platform.is('capacitor') &&  this.platform.is('ios');
  }

  isAndroidHibridApp(): boolean {
    return this.platform.is('capacitor') && this.platform.is('android');
  }
}
